module.exports = __webpack_public_path__ + "img/image_15.fa960142.jpg";